import type { IShowProps } from './types'

export default function Show<
  T,
  R extends Exclude<NonNullable<T>, false> = Exclude<NonNullable<T>, false>,
>({ when, children, fallback = null, checkFn = (v): v is R => !!v }: IShowProps<T, R>) {
  if (!checkFn(when)) {
    return <>{fallback}</>
  }

  return typeof children === 'function' ? children(when) : children
}
